import React from "react";
import { Row, Col } from "react-flexbox-grid";
// SCSS
import "./hero.scss";
//Assets
import HeroImage from '../../assets/hero/logo.png';
//Components
import Button from '../ui-components/button/button';

const translations = {
  en: {
    title: "Leave the cleaning to us and enjoy spotless results",
    button: "Reach Us",
  },
  ar: {
    title: "اترك التنظيف لنا واستمتع بنتائج لا تشوبها شائبة",
    button: "اتصل بنا",
  },
};

const Hero = ({ language }) => {
  const isArabic = language === "ar";

  return (
    <div className="hero" id="hero">
      <div className="wrapper">
        <Row>
          <Col md={12} lg={6}>
            <div className={`hero-info ${isArabic ? "rtl" : ""}`}>
              <h1 className="weight800 font60">
                {translations[language].title}
              </h1>
              <Button label={translations[language].button} target={"contact"} />
            </div>
          </Col>
          <Col md={12} lg={6}>
            <div className="hero-image">
              <img src={HeroImage} alt="hero" />
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Hero;

